import { DialogActions } from "@mui/material";
import DownloadButton from "./DownloadButton";
import { ActionButtons } from "./DialogStyles";

interface ModalActionsProps {
    selectedTransaction: any;
}

const ModalActions = ({ selectedTransaction }: ModalActionsProps) => {
    return (
        <DialogActions sx={{
            p: 2,
            borderTop: '1px solid #333',
            backgroundColor: '#1e1e1e',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            flexDirection: { xs: 'column', sm: 'row' }
        }}>
            <DownloadButton selectedTransaction={selectedTransaction} />
        </DialogActions>
    );
};

export default ModalActions;